import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RubenLearningHub from "@/pages/RubenLearningHub";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/learn/ruben")({
  head: () => seoHead("/learn/ruben"),
  component: () => (
    <AuthGate><RubenLearningHub /></AuthGate>
  ),
});
